export enum PaymentStatus {
  Paid,
  NotPaid,
}
